import React from 'react';
import './CropProduction.css';
import ServicesNav from './ServicesNav';
import crop2 from '../../assets/crop2.jpg'

const CropProduction = () => {
  return (
    <div className="crop-production-page">
      <ServicesNav />
      <div className="crop-content">
        <h1 className="title">Crop Production</h1>
        <p className="description">
          Explore sustainable techniques and modern advancements in crop production to maximize yield and ensure food security.
        </p>
        <img src={crop2} alt="Crop Production" className="crop-image" />
        
      </div>
    </div>
  );
};

export default CropProduction;
